module.exports = {
  env: 'preview',
  domain: ['preview.nges.qq.com'],
  mobileDomain: 'previewh5.nges.qq.com',
  aegisId: 'jlZIRgHXbxAFIWbChO',
  reportDomain: 'baike.sparta.html5.qq.com',
};
